import React from "react";
import Card from "../../components/card/Card";
import NsScrollableTabs from "../../components/NsScrollableTabs";
import FormModificaTipoImpExpController from "./components/FormModificaTipoImpExpController";

export default function ModificaTipoImpExpView({
                                                   id,
                                                   idClasse,
                                                   tipoImpExp,
                                                   history,
                                                   translate,
                                                   formikRefPrinc,
                                                   keyTab,
                                                   setKeyTab,
                                                   scrollableTabs,
                                                   bottoniSx,
                                                   bottoniDx,
                                               }) {

    return (
        <Card
            icon={'fas fa-building'}
            title={tipoImpExp && tipoImpExp.descrizione ? translate("Modifica tipo imp exp: ") + tipoImpExp.descrizione : 'Inserisci tipo imp exp'}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            {
                id ?
                    <FormModificaTipoImpExpController
                        id={id}
                        idClasse={idClasse}
                        history={history}
                        formikRef={formikRefPrinc}
                        principale={tipoImpExp && (!tipoImpExp.id_classe_tipo_imp_exp_madre || tipoImpExp.id_classe_tipo_imp_exp_madre === '')}
                        organizzazione={tipoImpExp}
                    />
                    :
                    <NsScrollableTabs
                        activeIndex={keyTab}
                        onTabChange={(e) => setKeyTab(e.index)}
                        scrollableTabs={scrollableTabs}
                    />
            }
        </Card>
    );
}